import GoBack from "@/components/GoBack";
import PaginationControls from "@/components/PaginationControls";
import ReviewBody from "@/components/ReviewBody";
import { Skeleton } from "@/components/ui/skeleton";
import { Order } from "@/types/ApiTypes";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

export default function Reviews() {
  const { t, i18n } = useTranslation();
  const [pageNum, setPageNum] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = useSelector((state: { auth: { token: string } }) => state.auth.token);
  const [orders, setOrders] = useState<Order[]>([])
  async function getReviews(page: number) {
    setLoading(true)
    try {
      const response = await axios.get(`${baseUrl}/api/dashboard/orders/reviews?locale=${i18n.language}`, {
        params: {
          page: page,
          length: pageNum,
        },
        headers: {
          Authorization: token,
        },
      })

      setOrders(response.data.reviews);
      setTotalItems(response.data.pagination.totalItems);
      setTotalPages(response.data.pagination.totalPages);
      setLoading(false)
    } catch (error) {
      console.error(error);
    } finally {

      setLoading(false)
    }
  }
  useEffect(() => {
    if (!token) return;
    getReviews(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, token, pageNum]);
  if (loading) return (
    <>

      <div className="mt-10">
        <Skeleton className="w-full h-[500px] dark:bg-slate-600 dark:bg-opacity-35   rounded-md" />
      </div>
    </>
  )
  return (
    <>
      <GoBack />
      <div className="overflow-x-auto">
        <table className="w-full text-sm  text-gray-500 bg-white  text-center whitespace-nowrap ">
          <thead className="text-xs text-gray-700 uppercase bg-white selection:bg-none ">
            <tr className="border-b">

              <th scope="col" className="px-6 py-3">
                {t("review.clientName")}
              </th>
              <th scope="col" className="px-6 py-3">
                {t("review.orderId")}
              </th>
              <th className="px-6 py-3">
                {t("review.orderReview")}
              </th>
              <th scope="col" className="px-6 py-3 ">
                {t("review.driverReview")}
              </th>
              <th scope="col" className="px-6 py-3 ">
                {t("review.theReview")}
              </th>
              <th scope="col" className="px-6 py-3">
                {t("orders.actions")}
              </th>
            </tr>
          </thead>
          <tbody>
            {orders && orders.map((order) => <ReviewBody key={order._id} order={order} />)}
          </tbody>
        </table>
      </div>
      <PaginationControls
        pageNum={pageNum}
        setPageNum={setPageNum}
        totalItems={totalItems}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
      />
    </>
  )
}
